/*
  © 2023 EcomGraduates.com
  https://www.ecomgraduates.com
*/

/*
  Main 'Add to cart' (ATC) form
*/
const removeExistingSubscriptionLinesForVariant = async (formData) => {
  const sellingPlan = formData.get('selling_plan')
  const variantId = Number(formData.get('id'))

  if (typeof sellingPlan !== 'string' || !sellingPlan.trim()) return
  if (!Number.isFinite(variantId) || variantId <= 0) return

  const cartResponse = await fetch('/cart.js')
  if (!cartResponse.ok) return

  const cart = await cartResponse.json()
  const matchingSubscriptionLines = (cart.items || []).filter((item) =>
    Number(item.variant_id) === variantId && item.selling_plan_allocation
  )

  for (const line of matchingSubscriptionLines) {
    await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: line.key,
        quantity: 0
      })
    })
  }
}

window.onSubmitAtcForm = async (form, event) => {
  event.preventDefault()

  const btn = form.querySelector('.btn-atc')
  btnInnerHTML = btn.innerHTML

  btn.innerHTML = `
    <div class="spinner-border spinner-border-sm" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
    `

  form.classList.add('loading')

  let formData
  formData = await getFormDataFromQtyBreaks(form)

  if (!formData) {
    formData = new FormData(form)
  }

  await removeExistingSubscriptionLinesForVariant(formData)

  console.log(...formData)

  const response = await fetch('/cart/add.js', { method: 'POST', body: formData })

  form.classList.remove('loading')


  btn.innerHTML = window.theme.product.addedToCart

  setTimeout(() => {
    btn.innerHTML = btnInnerHTML
  }, 2000)

  window.refreshCartContents(response)

  if (form.hasAttribute('data-ecomify-upsell-modal')) return
  if (btn.closest('.modal')) return

  if (document.querySelector('#offcanvas-cart')) {
    bootstrap.Offcanvas.getOrCreateInstance('#offcanvas-cart').show()
  }

  const _learnq = window._learnq || []
  _learnq.push(['track', 'Added to Cart', {
    ProductID: form.dataset.productId,
    Name: form.dataset.productTitle,
    URL: form.dataset.productUrl
  }])
}

/*
  'Add to cart' form based on variant
*/
window.onClickAtcFormVariant = async (btn, event) => {
  const form = btn.closest('form')
  form.querySelector('[name="id"]').value = btn.dataset.variantId

  window.onSubmitAtcForm(form, event)
}

const getSellingPlanFrequencyToken = (value) => {
  const match = String(value || '').match(/\d+/)

  return match ? match[0] : String(value || '').trim().toLowerCase()
}

const getSellingPlanAllocationId = (allocation) =>
  allocation?.selling_plan_id || allocation?.selling_plan?.id

const formatMoneyWithoutTrailingZeros = (price) =>
  Shopify.formatMoney(price).replace(/\.00\b/g, '')

const getVariantLoadCount = (variant) => {
  const values = [variant?.title, ...(variant?.options || [])]

  for (const value of values) {
    const valueString = String(value || '')
    const loadMatch = valueString.match(/(\d+)\s*(loads?|cargas?)/i)

    if (loadMatch) return Number(loadMatch[1])

    const numberMatch = valueString.match(/(^|\D)(\d+)(\D|$)/)

    if (numberMatch) return Number(numberMatch[2])
  }

  return null
}

const getPurchaseOptionsWrapper = (element) =>
  element?.closest?.('#product-purchase-options') || document.querySelector('#product-purchase-options')

const getCostPerLoadLabel = (price, variant, suffix = '/carga') => {
  const priceCents = Number(price)
  const loadCount = getVariantLoadCount(variant)

  if (!Number.isFinite(priceCents) || !Number.isFinite(loadCount) || loadCount <= 0) return ''

  return `${formatMoneyWithoutTrailingZeros(Math.round(priceCents / loadCount))}${suffix}`
}

const updateCostPerLoadLabel = (label, price, variant) => {
  if (!label) return

  const wrapper = getPurchaseOptionsWrapper(label)
  const suffix = wrapper?.dataset.costPerLoadSuffix || '/carga'

  label.textContent = getCostPerLoadLabel(price, variant, suffix)
}

const getSellingPlanSaveAmount = (variant, allocation) => {
  const price = Number(variant?.price)
  const allocationPrice = Number(allocation?.price)

  if (!Number.isFinite(price) || !Number.isFinite(allocationPrice) || price <= 0) return null

  return Math.max(0, Math.ceil((price - allocationPrice) / 100))
}

const renderSellingPlanSaveAmountLabel = (label, saveAmount, wrapper) => {
  if (!label || !Number.isFinite(saveAmount) || saveAmount <= 0) {
    if (label) label.textContent = ''
    return
  }

  const template = wrapper?.dataset.savingsTemplate || 'AHORRA __SAVINGS__ EN CADA ENTREGA'
  const [prefix = '', suffix = ''] = template.split('__SAVINGS__')
  const amount = document.createElement('span')
  const money = formatMoneyWithoutTrailingZeros(saveAmount * 100)
    .replace(/(\D)\s+(?=\d)/g, '$1')
    .trim()

  amount.className = 'purchase-options-savings-amount'
  amount.textContent = money

  label.replaceChildren(
    document.createTextNode(prefix.trimEnd() ? `${prefix.trimEnd()} ` : ''),
    amount,
    document.createTextNode(suffix.trimStart() ? ` ${suffix.trimStart()}` : '')
  )
}

const renderSellingPlanSaveLabel = (label, variant, allocation, wrapper) => {
  const saveAmount = getSellingPlanSaveAmount(variant, allocation)

  renderSellingPlanSaveAmountLabel(label, saveAmount, wrapper)
}

const updatePurchaseOptionsForVariant = (wrapper, selectedVariant) => {
  const oneTimeInput = wrapper.querySelector('input#purchase-options-one-time')
  const oneTimePriceLabel = wrapper.querySelector('input#purchase-options-one-time + label [data-price]')
  const oneTimeCostPerLoadLabel = wrapper.querySelector('input#purchase-options-one-time + label [data-cost-per-load]')
  const subscriptionInput = wrapper.querySelector('input#purchase-options-subscription')
  const subscriptionPriceLabel = wrapper.querySelector('input#purchase-options-subscription + label [data-price]')
  const subscriptionCompareLabel = wrapper.querySelector('input#purchase-options-subscription + label [data-compare-price]')
  const subscriptionCostPerLoadLabel = wrapper.querySelector('input#purchase-options-subscription + label [data-cost-per-load]')
  const subscriptionSaveLabel = wrapper.querySelector('#purchase-options-subscription-save')
  const sellingPlanSelect = wrapper.querySelector('[name="selling_plan"]')

  if (oneTimeInput) {
    oneTimeInput.setAttribute('data-price', selectedVariant.price)
  }

  if (oneTimePriceLabel) {
    oneTimePriceLabel.textContent = formatMoneyWithoutTrailingZeros(selectedVariant.price)
  }

  updateCostPerLoadLabel(oneTimeCostPerLoadLabel, selectedVariant.price, selectedVariant)

  const allocations = selectedVariant.selling_plan_allocations || []

  if (!allocations.length || !subscriptionInput) return

  const selectedIndex = sellingPlanSelect?.selectedIndex >= 0 ? sellingPlanSelect.selectedIndex : 0
  const options = Array.from(sellingPlanSelect?.options || [])

  options.forEach((option, index) => {
    const allocationById = allocations.find((allocation) =>
      Number(getSellingPlanAllocationId(allocation)) === Number(option.value)
    )
    const allocation = allocationById || allocations[index]
    const allocationId = getSellingPlanAllocationId(allocation)

    if (!allocation || !allocationId) return

    option.value = allocationId
    option.dataset.price = allocation.price
    option.dataset.saveAmount = getSellingPlanSaveAmount(selectedVariant, allocation)
    option.dataset.frequencyToken = getSellingPlanFrequencyToken(option.textContent)
  })

  const defaultIndex = options.findIndex((option) => option.dataset.frequencyToken === '30')
  const nextSelectedIndex = defaultIndex >= 0 ? defaultIndex : Math.max(0, selectedIndex)

  if (sellingPlanSelect?.options[nextSelectedIndex]) {
    sellingPlanSelect.selectedIndex = nextSelectedIndex
    sellingPlanSelect.options[nextSelectedIndex].selected = true
  }

  const selectedSellingPlanOption = sellingPlanSelect?.options[sellingPlanSelect.selectedIndex]
  const selectedAllocation = allocations.find((allocation) =>
    Number(getSellingPlanAllocationId(allocation)) === Number(selectedSellingPlanOption?.value)
  ) || allocations[0]
  const subscriptionPrice = selectedSellingPlanOption?.dataset.price || selectedAllocation.price

  subscriptionInput.setAttribute('data-price', subscriptionPrice)

  if (subscriptionPriceLabel) {
    subscriptionPriceLabel.textContent = formatMoneyWithoutTrailingZeros(subscriptionPrice)
  }

  if (subscriptionCompareLabel) {
    subscriptionCompareLabel.textContent = formatMoneyWithoutTrailingZeros(selectedVariant.price)
  }

  updateCostPerLoadLabel(subscriptionCostPerLoadLabel, subscriptionPrice, selectedVariant)

  renderSellingPlanSaveLabel(subscriptionSaveLabel, selectedVariant, selectedAllocation, wrapper)
}

/*
  Product options selector - Listen for change events
*/
window.onChangeProductOption = async (input) => {
  const selectedOptions = []

  input.closest('form').querySelectorAll('.product-option').forEach(elem => {
    if (elem.type === 'radio') {
      if (elem.checked) {
        selectedOptions.push(elem.value)
      }
    } else {
      selectedOptions.push(elem.value)
    }
  })

  const selectedVariant = JSON.parse(input.closest('form').dataset.variants).find(variant =>
    JSON.stringify(variant.options) === JSON.stringify(selectedOptions)
  )

  console.log(selectedVariant)

  const btn = input.closest('form').querySelector('.btn-atc')

  if (selectedVariant) {
    const selectedVariantOption = input.closest('form')
      .querySelector(`.product-option[data-variant-id="${selectedVariant.id}"]`)
    const featuredMediaPosition = Number(selectedVariantOption?.dataset.variantFeaturedMediaPosition)
    const featuredMediaId = Number(selectedVariantOption?.dataset.variantFeaturedMediaId)

    if (Number.isFinite(featuredMediaPosition) && featuredMediaPosition > 0) {
      selectedVariant.featured_media = selectedVariant.featured_media || {}
      selectedVariant.featured_media.position = featuredMediaPosition

      if (Number.isFinite(featuredMediaId) && featuredMediaId > 0) {
        selectedVariant.featured_media.id = featuredMediaId
      }
    }

    input.closest('form').querySelector('[name="id"]').value = selectedVariant.id

    if (selectedVariant.available) {
      btn.disabled = false
      btn.querySelector('.btn-atc-text').innerHTML = `${window.theme.product.addToCart}`
    } else {
      btn.disabled = true
      btn.querySelector('.btn-atc-text').innerHTML = `${window.theme.product.soldOut}`
    }

    // Update price display with consistent compare at price logic and dynamic currency
    const priceContainer = input.closest('.product-content').querySelector('.product-price')

    if (priceContainer) {
      if (selectedVariant.compare_at_price && selectedVariant.compare_at_price > selectedVariant.price) {
        priceContainer.innerHTML = `
          <span class="product-price-compare text-muted me-3">
              <span class="visually-hidden">
                ${window.theme.product.priceFrom} &nbsp;
              </span>
              <s>${selectedVariant.compare_at_price > selectedVariant.price ? formatMoneyWithoutTrailingZeros(selectedVariant.compare_at_price) : ''}</s>
          </span>
          <span class="product-price-final">
            <span class="visually-hidden">
              ${window.theme.product.priceSale} &nbsp;
            </span>
            ${formatMoneyWithoutTrailingZeros(selectedVariant.price)}
        </span>
              `
      } else {
        priceContainer.innerHTML = `
          <span class="product-price-final">
            ${formatMoneyWithoutTrailingZeros(selectedVariant.price)}
          </span>
        `
      }

      if (selectedVariant.available && selectedVariant.compare_at_price) {
        if (priceContainer.dataset.saleBadgeType === 'percentage') {
          priceContainer.insertAdjacentHTML('beforeend', `
            <span class="price-badge-sale badge ${priceContainer.dataset.saleBadgeColor}">
              ${window.theme.product.save}: ${Math.round((1 - (selectedVariant.price / selectedVariant.compare_at_price)) * 100)}%
            </span>
          `)
        } else {
          priceContainer.insertAdjacentHTML('beforeend', `
            <span class="price-badge-sale badge ${priceContainer.dataset.saleBadgeColor}">
              ${window.theme.product.save}: ${formatMoneyWithoutTrailingZeros(selectedVariant.compare_at_price - selectedVariant.price)}
            </span>
          `)
        }
      } else if (!selectedVariant.available) {
        priceContainer.insertAdjacentHTML('beforeend', `
          <span class="price-badge-sold-out badge">
            ${window.theme.product.soldOut}
          </span>
        `)
      }
    }

    const purchaseOptionsWrapper = document.querySelector('#product-purchase-options')

    if (purchaseOptionsWrapper) {
      updatePurchaseOptionsForVariant(purchaseOptionsWrapper, selectedVariant)
      purchaseOptionsWrapper.dispatchEvent(new CustomEvent('nada:purchase-options:update'))
    }

    const skuWrapper = input.closest('.product-content').querySelector('.current-variant-sku')

    if (skuWrapper) {
      if (selectedVariant.sku.length) {
        skuWrapper.textContent = selectedVariant.sku
        skuWrapper.removeAttribute('hidden')
      } else {
        skuWrapper.setAttribute('hidden', 'hidden')
      }
    }

    if (input.closest('#product-template')) {
      const url = new URL(window.location)
      url.searchParams.set('variant', selectedVariant.id)
      window.history.replaceState({}, '', url)
    }

    if (btn.querySelector('.btn-atc-price')) {
      const subscriptionInput = document.querySelector('#product-purchase-options input#purchase-options-subscription')
      const isSubscriptionSelected = subscriptionInput?.checked

      if (isSubscriptionSelected) {
        btn.querySelector('.btn-atc-price').textContent = formatMoneyWithoutTrailingZeros(subscriptionInput.dataset.price)
      } else {
        btn.querySelector('.btn-atc-price').textContent = formatMoneyWithoutTrailingZeros(selectedVariant.price)
      }
    }

    const customEvent = new CustomEvent('variantChange.ecomify.product', {
      detail: selectedVariant
    })
    window.dispatchEvent(customEvent)
  } else {
    btn.disabled = true
    btn.querySelector('.btn-atc-text').textContent = window.theme.product.unavailable
  }

  if (input.closest('.color-swatches')) {
    input.closest('.product-option-wrapper').querySelector('.color-swatches-title span')
      .textContent = input.value
  }

  if (input.closest('.size-buttons')) {
    input.closest('.product-option-wrapper').querySelector('.size-buttons-title span')
      .textContent = input.value
  }
}

/*
  Update various elements on variant change that need a new document fetch
*/
window.addEventListener('variantChange.ecomify.product', async (event) => {
  const inventoryBar = document.querySelector('#inventory-bar')

  if (inventoryBar) {
    inventoryBar.style.opacity = '.25'
  }

  const respoonse = await fetch(window.location.href)
  const text = await respoonse.text()
  const newDocument = new DOMParser().parseFromString(text, 'text/html')

  document.querySelector('#inventory-bar')
    ?.replaceWith(newDocument.querySelector('#inventory-bar'))
  document.querySelector('#product-qty-breaks')
    ?.replaceWith(newDocument.querySelector('#product-qty-breaks'))

  document.querySelector('#product-store-availability-wrapper')
    ?.replaceWith(newDocument.querySelector('#product-store-availability-wrapper'))

  if (document.querySelector('.page-type-product')) {
    document.querySelector('.product-variant-selector')
      ?.replaceWith(newDocument.querySelector('.product-variant-selector'))
  }

  initInventoryBar()
  initQtyBreaks()

  if (document.querySelector('.product-gallery-variant-based')) {
    document.querySelector('.product-gallery-variant-based')
      ?.replaceWith(newDocument.querySelector('.product-gallery-variant-based'))
    initProductGallery()
  }

  if (document.querySelector('#product-block-variant-description')) {
    document.querySelector('#product-block-variant-description')
      ?.replaceWith(newDocument.querySelector('#product-block-variant-description'))
  }

  document.querySelectorAll('[role="tooltip"]')
    .forEach(el => el.remove())

  document.querySelectorAll('.product-options [data-bs-toggle="tooltip"]')
    .forEach((el) => new bootstrap.Tooltip(el))
})

/*
    Purchase options (selling/subscription plans)
*/
const initPurchaseOptions = () => {
  const wrapper = document.querySelector('#product-purchase-options')

  if (!wrapper) return

  const getCurrentVariant = () => {
    const form = wrapper.closest('form')
    const variantId = Number(form?.querySelector('[name="id"]')?.value)

    if (!form?.dataset.variants || !Number.isFinite(variantId)) return null

    try {
      return JSON.parse(form.dataset.variants).find((variant) => Number(variant.id) === variantId) || null
    } catch (error) {
      return null
    }
  }

  const getSelectedSellingPlanPrice = (sellingPlanSelect, fallbackPrice) => {
    const selectedOption = sellingPlanSelect?.options[sellingPlanSelect.selectedIndex]

    return selectedOption?.dataset.price || fallbackPrice
  }

  const syncPurchaseOptions = () => {
    const form = wrapper.closest('form')
    const selectedInput = wrapper.querySelector('[name="purchase_option"]:checked')
    const deliveryOptions = wrapper.querySelector('#purchase-delivery-options')
    const sellingPlanSelect = wrapper.querySelector('[name="selling_plan"]')
    const btnAtc = form?.querySelector('.btn-atc')
    const btnAtcPrice = form?.querySelector('.btn-atc-price')
    const currentVariant = getCurrentVariant()
    const oneTimePriceLabel = wrapper.querySelector('input#purchase-options-one-time + label [data-price]')
    const oneTimeCostPerLoadLabel = wrapper.querySelector('input#purchase-options-one-time + label [data-cost-per-load]')
    const subscriptionCompareLabel = wrapper.querySelector('input#purchase-options-subscription + label [data-compare-price]')
    const subscriptionCostPerLoadLabel = wrapper.querySelector('input#purchase-options-subscription + label [data-cost-per-load]')

    if (currentVariant) {
      if (oneTimePriceLabel) {
        oneTimePriceLabel.textContent = formatMoneyWithoutTrailingZeros(currentVariant.price)
      }

      if (subscriptionCompareLabel) {
        subscriptionCompareLabel.textContent = formatMoneyWithoutTrailingZeros(currentVariant.price)
      }

      updateCostPerLoadLabel(oneTimeCostPerLoadLabel, currentVariant.price, currentVariant)

      const subscriptionInputForDisplay = wrapper.querySelector('input#purchase-options-subscription')
      const subscriptionPriceLabelForDisplay = wrapper.querySelector('input#purchase-options-subscription + label [data-price]')
      const subscriptionSaveLabelForDisplay = wrapper.querySelector('#purchase-options-subscription-save')
      const selectedSellingPlanOptionForDisplay = sellingPlanSelect?.options[sellingPlanSelect.selectedIndex]
      const selectedAllocationForDisplay = currentVariant.selling_plan_allocations?.find((allocation) =>
        Number(getSellingPlanAllocationId(allocation)) === Number(selectedSellingPlanOptionForDisplay?.value)
      )
      const subscriptionPriceForDisplay = getSelectedSellingPlanPrice(
        sellingPlanSelect,
        subscriptionInputForDisplay?.dataset.price
      )
      const saveAmountForDisplay = Number(
        selectedSellingPlanOptionForDisplay?.dataset.saveAmount || getSellingPlanSaveAmount(currentVariant, selectedAllocationForDisplay)
      )

      if (subscriptionInputForDisplay && subscriptionPriceForDisplay) {
        subscriptionInputForDisplay.dataset.price = subscriptionPriceForDisplay
      }

      if (subscriptionPriceLabelForDisplay && subscriptionPriceForDisplay) {
        subscriptionPriceLabelForDisplay.textContent = formatMoneyWithoutTrailingZeros(subscriptionPriceForDisplay)
      }

      updateCostPerLoadLabel(subscriptionCostPerLoadLabel, subscriptionPriceForDisplay, currentVariant)

      renderSellingPlanSaveAmountLabel(subscriptionSaveLabelForDisplay, saveAmountForDisplay, wrapper)
    }

    if (!selectedInput) {
      deliveryOptions?.removeAttribute('hidden')

      if (sellingPlanSelect) {
        sellingPlanSelect.disabled = true
      }

      form?.removeAttribute('data-nada-purchase-ready')

      if (btnAtc) {
        btnAtc.dataset.nadaDisabledByPurchase = 'true'
        btnAtc.disabled = true
      }

      return
    }

    form?.setAttribute('data-nada-purchase-ready', 'true')

    if (selectedInput.id === 'purchase-options-one-time') {
      deliveryOptions?.removeAttribute('hidden')

      if (sellingPlanSelect) {
        sellingPlanSelect.disabled = true
      }

      if (selectedInput.closest('#product-template')) {
        const url = new URL(window.location)
        url.searchParams.delete('selling_plan')
        window.history.replaceState({}, '', url)
      }
    } else {
      deliveryOptions?.removeAttribute('hidden')

      if (sellingPlanSelect) {
        sellingPlanSelect.disabled = false
      }

      const subscriptionPrice = getSelectedSellingPlanPrice(sellingPlanSelect, selectedInput.dataset.price)
      const subscriptionPriceLabel = wrapper.querySelector('input#purchase-options-subscription + label [data-price]')
      const subscriptionSaveLabel = wrapper.querySelector('#purchase-options-subscription-save')
      const selectedSellingPlanOption = sellingPlanSelect?.options[sellingPlanSelect.selectedIndex]
      const selectedAllocation = currentVariant?.selling_plan_allocations?.find((allocation) =>
        Number(getSellingPlanAllocationId(allocation)) === Number(selectedSellingPlanOption?.value)
      )
      const saveAmount = Number(
        selectedSellingPlanOption?.dataset.saveAmount || getSellingPlanSaveAmount(currentVariant, selectedAllocation)
      )

      selectedInput.dataset.price = subscriptionPrice

      if (subscriptionPriceLabel) {
        subscriptionPriceLabel.textContent = formatMoneyWithoutTrailingZeros(subscriptionPrice)
      }

      updateCostPerLoadLabel(subscriptionCostPerLoadLabel, subscriptionPrice, currentVariant)

      renderSellingPlanSaveAmountLabel(subscriptionSaveLabel, saveAmount, wrapper)

      if (selectedInput.closest('#product-template') && sellingPlanSelect) {
        const url = new URL(window.location)
        url.searchParams.set('variant', wrapper.closest('.product-content').querySelector('[name="id"]').value)
        url.searchParams.set('selling_plan', sellingPlanSelect.value)
        window.history.replaceState({}, '', url)
      }
    }

    if (btnAtcPrice) {
      btnAtcPrice.textContent = formatMoneyWithoutTrailingZeros(selectedInput.dataset.price)
    }

    if (btnAtc?.dataset.nadaDisabledByPurchase === 'true') {
      if (!currentVariant || currentVariant.available) {
        btnAtc.disabled = false
      }

      delete btnAtc.dataset.nadaDisabledByPurchase
    }
  }

  wrapper.querySelectorAll('[name="purchase_option"]').forEach(input => {
    input.addEventListener('change', syncPurchaseOptions)
  })

  const deliverEverySelect = wrapper.querySelector('#purchase-delivery-options-select')

  if (deliverEverySelect) {
    deliverEverySelect.addEventListener('change', () => {
      if (deliverEverySelect.closest('#product-template')) {
        const url = new URL(window.location)
        url.searchParams.set('selling_plan', wrapper.querySelector('[name="selling_plan"]').value)
        window.history.replaceState({}, '', url)
      }

      syncPurchaseOptions()
    })
  }

  wrapper.addEventListener('nada:purchase-options:update', syncPurchaseOptions)

  const defaultOneTimeInput = wrapper.querySelector('input#purchase-options-one-time')
  const defaultSubscriptionInput = wrapper.querySelector('input#purchase-options-subscription')

  if (defaultOneTimeInput) {
    defaultOneTimeInput.checked = true
  }

  if (defaultSubscriptionInput) {
    defaultSubscriptionInput.checked = false
  }

  syncPurchaseOptions()
}
initPurchaseOptions()

// Product Item - Handle variant change
window.onChangeProductItemVariant = (select, event) => {
  if (select.options[select.selectedIndex].dataset.variantImage?.length) {
    select.closest('.product-item').querySelector('.product-item-img').src =
      select.options[select.selectedIndex].dataset.variantImage
  }

  const compareAtPrice = select.options[select.selectedIndex].dataset.compareAtPrice
  const price = select.options[select.selectedIndex].dataset.price

  if (compareAtPrice.length) {
    select.closest('.product-item').querySelector('.product-item-price').innerHTML = `
            <span class="product-item-price-compare text-muted me-1">
                <span class="visually-hidden">
                    ${window.theme.product.priceFrom} &nbsp;
                </span>
                 
                    ${Shopify.formatMoney(compareAtPrice)}
                
            </span>
            <span class="product-item-price-final">
                <span class="visually-hidden">
                    ${window.theme.product.priceSale} &nbsp;
                </span>
                ${Shopify.formatMoney(price)}
            </span>
        `
  } else {
    select.closest('.product-item').querySelector('.product-item-price').innerHTML = `
            <span class="product-item-price-final">
                ${Shopify.formatMoney(price)}
            </span>
        `
  }
}

// Product Item - Handle swatches change
window.onChangeProductItemSwatches = (btn, event) => {
  const productItem = btn.closest('.product-item')

  if (productItem.querySelector('.product-carousel')) {
    productItem.querySelector('.product-carousel .carousel-inner').insertAdjacentHTML('beforeend', `
            <div class="carousel-item">
                <img
                    class="product-item-img img-fluid rounded ${btn.dataset.imgThumbnail}"
                    src="${btn.dataset.img}"
                    alt=""
                    width="${btn.dataset.imgWidth}"
                    height="${btn.dataset.imgHeight}"
                    loading="lazy">
            </div>
        `)
    const index = productItem.querySelectorAll('.product-carousel .carousel-item').length - 1
    bootstrap.Carousel.getOrCreateInstance(productItem.querySelector('.product-carousel')).to(index)
  } else {
    productItem.querySelector('.product-item-img').setAttribute('src', btn.dataset.img)
  }
}

/*
    'Buy it now' button
*/
window.onClickBuyBtn = (btn) => {
  btn.innerHTML = `
        <div class="spinner-border spinner-border-sm" role="status">
            <span class="visually-hidden">Loading...</span>
        </div>
    `
  const form = btn.closest('form')
  const variantId = form.querySelector('[name="id"]').value
  const qty = Number(form.querySelector('input[name="quantity"]')?.value || 1)
  window.location.href = `/cart/${variantId}:${qty}`
}

/*
    Product Gallery
*/
function initProductGallery () {
  document.querySelectorAll('.product-gallery:not(.init)').forEach(gallery => {
    gallery.classList.add('init')

    const totalSlides = gallery.querySelectorAll('.main-splide .splide__slide').length

    const mainSplideElement = gallery.querySelector('.main-splide')

    const main = new Splide(mainSplideElement, {
      start: Number(gallery.dataset.start),
      rewind: totalSlides > 1,
      arrows: Number(gallery.dataset.mediaCount > 1) && gallery.dataset.arrows === 'main-slider' && totalSlides > 1,
      rewindByDrag: totalSlides > 1,
      drag: totalSlides > 1,
      pagination: false,
      noDrag: 'model-viewer',
      mediaQuery: 'min',
      breakpoints: {
        0: { padding: { right: gallery.dataset.showThumbsMobile === 'false' ? '4rem' : 0 } },
        992: { padding: 0 }
      },
      direction: document.documentElement.getAttribute('dir')
    })

    if (totalSlides === 1) {
      // Disable all interactivity for single image
      // mainSplideElement.style.pointerEvents = 'none'
      // mainSplideElement.style.touchAction = 'none'
      mainSplideElement.querySelector('.splide__track').style.overflow = 'hidden'
    }

    const thumbs = new Splide(gallery.querySelector('.thumbs-splide'), {
      start: Number(gallery.dataset.start),
      arrows: Number(gallery.dataset.mediaCount > 3) && gallery.dataset.arrows === 'thumbs-slider' && totalSlides > 1,
      gap: '.5rem',
      rewind: totalSlides > 1,
      rewindByDrag: totalSlides > 1,
      pagination: false,
      isNavigation: totalSlides > 1,
      focus: totalSlides > 5 ? 'center' : 0,
      mediaQuery: 'min',
      breakpoints: {
        0: { perPage: 5 },
        576: { perPage: 5 },
        768: { perPage: 5 },
        992: { perPage: 5 },
        1200: { perPage: 5 },
        1400: { perPage: 5 }
      },
      direction: document.documentElement.getAttribute('dir')
    })

    main.on('move', (newIndex, prevIndex) => {
      const prevSlide = gallery.querySelector(`.splide__slide:nth-child(${prevIndex + 1}`)

      if (prevSlide) {
        if (prevSlide.querySelector('iframe')) {
          prevSlide.querySelector('iframe').src = prevSlide.querySelector('iframe').src
        }
        if (prevSlide.querySelector('video')) {
          prevSlide.querySelector('video').pause()
        }
      }

      const currentSlide = gallery.querySelector(`.splide__slide:nth-child(${newIndex + 1}`)

      if (currentSlide) {
        if (currentSlide.querySelector('video')) {
          if (currentSlide.querySelector('video').dataset.autoplay === 'true') {
            currentSlide.querySelector('video').play()
          }
        }
      }
    })

    window.addEventListener('variantChange.ecomify.product', (event) => {
      if (main.root.closest('.product-gallery-variant-based')) return

      const selectedVariant = event.detail

      if (selectedVariant.featured_media && totalSlides > 1) {
        main.go(selectedVariant.featured_media.position - 1)
      }
    }, false)

    if (totalSlides > 1) {
      main.sync(thumbs)
      main.mount()
      thumbs.mount()
    } else {
      main.mount()
      gallery.querySelector('.thumbs-splide')?.remove()
    }

    if (window.matchMedia('(min-width: 992px)').matches) {
      const navbarHeight = document.querySelector('#navbar-desktop')?.clientHeight || 0
      const announcementBarHeight = document.querySelector('[id*="__announcement-bar"].sticky-top')?.clientHeight || 0

      const galleryWrapper = gallery.closest('.product-gallery-wrapper')
      if (!galleryWrapper) return

      galleryWrapper.style.position = 'sticky'
      galleryWrapper.style.top = `${navbarHeight + announcementBarHeight + 20}px`
      galleryWrapper.style.zIndex = '1'
    }

    if (window.GLightbox) {
      // eslint-disable-next-line no-unused-vars
      const lightbox = GLightbox({
        selector: `[data-gallery="product-gallery-${gallery.dataset.productId}"]`,
        videosWidth: '1290px',
        loop: totalSlides > 1
      })
      lightbox.on('open', () => {
        gallery.querySelectorAll('video').forEach(video => {
          video.pause()
        })
      })
      lightbox.on('slide_changed', ({ prev, current }) => {
        if (totalSlides > 1) {
          main.go(current.index)
        }
      })
    }

    const modelViewer = gallery.querySelector('model-viewer')

    if (modelViewer) {
      const increaseBtn = gallery.querySelector('[data-model-3d-increase-zoom]')
      const decreaseBtn = gallery.querySelector('[data-model-3d-decrease-zoom]')
      const fullscreenBtn = gallery.querySelector('[data-model-3d-fullscreen]')

      increaseBtn.addEventListener('click', () => {
        modelViewer.zoom(1)
      })

      decreaseBtn.addEventListener('click', () => {
        modelViewer.zoom(-1)
      })

      fullscreenBtn.addEventListener('click', () => {
        if (document.fullscreenElement) {
          document.exitFullscreen()
          fullscreenBtn.querySelector('.bi-fullscreen').removeAttribute('hidden')
          fullscreenBtn.querySelector('.bi-fullscreen-exit').setAttribute('hidden', 'hidden')
        } else {
          modelViewer.closest('.product-gallery-model-3d').requestFullscreen()
          fullscreenBtn.querySelector('.bi-fullscreen').setAttribute('hidden', 'hidden')
          fullscreenBtn.querySelector('.bi-fullscreen-exit').removeAttribute('hidden')
        }
      })
    }
  })
}
initProductGallery()

document.addEventListener('shopify:section:load', (e) => {
  if (e.target.querySelector('.product-gallery')) {
    initProductGallery()
  }
})

window.addEventListener('updated.ecomify.collection', initProductGallery)

/*
    Inventory Bar
*/
function initInventoryBar () {
  const wrapper = document.querySelector('#inventory-bar')

  if (!wrapper) return

  const progressBar = wrapper.querySelector('.progress-bar')

  setTimeout(() => {
    progressBar.style.width = progressBar.dataset.width
  }, 250)
}
initInventoryBar()

document.addEventListener('shopify:section:load', (e) => {
  if (e.target.querySelector('#inventory-bar')) {
    initInventoryBar()
  }
})

/*
    Upsell modal
*/
const initUpsellModal = () => {
  const modal = document.querySelector('#product-upsell-modal')
  if (!modal) return

  const form = document.querySelector('#product-content form[onsubmit*="onSubmitAtcForm"]')
  if (!form) return

  form.setAttribute('data-ecomify-upsell-modal', 'true')

  form.addEventListener('submit', (e) => {
    const modal = bootstrap.Modal.getOrCreateInstance('#product-upsell-modal')
    modal.show()
  })

  document.querySelectorAll('#product-upsell-modal .btn-atc').forEach(btn => {
    btn.addEventListener('click', () => {
      const footerBtn = document.querySelector('#product-upsell-modal .modal-footer .btn')
      footerBtn.classList.remove(footerBtn.dataset.defaultClass)
      footerBtn.classList.add(footerBtn.dataset.activeClass)
    })
  })

  modal.addEventListener('hidden.bs.modal', () => {
    if (document.querySelector('#offcanvas-cart')) {
      const offcanvasCart = bootstrap.Offcanvas.getOrCreateInstance('#offcanvas-cart')
      offcanvasCart.show()
    }
  })
}
initUpsellModal()

document.addEventListener('shopify:section:load', (e) => {
  if (e.target.querySelector('#product-upsell-modal')) {
    initUpsellModal()
  }
})

/*
    Bought Together
*/
const initBoughtTogether = () => {
  if (!document.querySelector('#product-bought-together')) return

  const setTotalPrice = () => {
    let totalCompareAtPrice = 0
    let totalPrice = 0

    document.querySelectorAll('#product-bought-together .product-item-price').forEach(elem => {
      if (elem.closest('.product-item').querySelector('.bought-together-check:checked')) {
        totalCompareAtPrice += elem.dataset.compareAtPrice.length ? Number(elem.dataset.compareAtPrice) : Number(elem.dataset.price)
        totalPrice += Number(elem.dataset.price)
      }
    })

    const totalElem = document.querySelector('#bought-together-total')

    if (totalCompareAtPrice > totalPrice) {
      totalElem.innerHTML = `
                ${totalElem.dataset.textTotalPrice}: 
                <span class="bought-together-total-compare-price text-muted me-2">
                    <span class="visually-hidden">
                        ${window.theme.product.priceFrom} &nbsp;
                    </span>
                     
                        ${Shopify.formatMoney(totalCompareAtPrice)}
                    
                </span>
                <span class="bought-together-total-price text-success">
                    <span class="visually-hidden">
                        ${window.theme.product.priceSale} &nbsp;
                    </span>
                    ${Shopify.formatMoney(totalPrice)}
                </span>
            `
    } else {
      totalElem.innerHTML = `
                ${totalElem.dataset.textTotalPrice}: 
                <span class="bought-together-total-price">
                    ${Shopify.formatMoney(totalPrice)}
                </span>
            `
    }
  }

  document.querySelectorAll('.bought-together-check').forEach((checkbox) => {
    checkbox.addEventListener('change', () => {
      if (checkbox.checked) {
        checkbox.closest('.product-item').style.opacity = '1'
      } else {
        checkbox.closest('.product-item').style.opacity = '.5'
      }

      if (document.querySelector('.bought-together-check:checked')) {
        document.querySelector('#bought-together-atc').disabled = false
      } else {
        document.querySelector('#bought-together-atc').disabled = true
      }

      setTotalPrice()
    })
  })

  document.querySelectorAll('#product-bought-together select[name="id"]').forEach(select => {
    select.addEventListener('change', () => {
      const compareAtPrice = select.options[select.selectedIndex].dataset.compareAtPrice
      const price = select.options[select.selectedIndex].dataset.price

      select.closest('.product-item').querySelector('.product-item-price')
        .setAttribute('data-compare-at-price', compareAtPrice)
      select.closest('.product-item').querySelector('.product-item-price')
        .setAttribute('data-price', price)

      setTotalPrice()
    })
  })

  document.querySelector('#bought-together-atc').addEventListener('click', async (e) => {
    const btn = e.target

    btn.style.width = btn.clientWidth + 4 + 'px'
    btn.innerHTML = `
            <div class="spinner-border spinner-border-sm" role="status">
                <span class="visually-hidden">Loading...</span>
            </div>
        `

    const items = []

    document.querySelectorAll('#product-bought-together .product-item').forEach(elem => {
      if (elem.querySelector('.bought-together-check:checked')) {
        items.push({
          id: Number(elem.querySelector('[name="id"]').value),
          quantity: 1
        })
      }
    })

    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items })
    })

    btn.innerHTML = window.theme.product.addedToCart

    setTimeout(() => {
      btn.innerHTML = btn.dataset.textAddToCart
    }, 2000)

    window.refreshCartContents(response)

    bootstrap.Offcanvas.getOrCreateInstance('#offcanvas-cart').show()
  })
}
initBoughtTogether()

/*
  Qty Breaks
*/
const getSelectedSellingPlan = (form) => {
  const sellingPlan = new FormData(form).get('selling_plan')

  return typeof sellingPlan === 'string' ? sellingPlan.trim() : ''
}

const getSelectedQtyBreakGroup = (qtyBreaks) => {
  const selectedInput = qtyBreaks?.querySelector('input[name="product-qty-breaks"]:checked')

  return selectedInput?.closest('.product-qty-break') || null
}

const sealAppBlockId = 'seal_subscriptions_subscription_widget_JkVxqd'
const sealAppBlockSelector = `.shopify-app-block[id*="${sealAppBlockId}"], .shopify-app-block[data-shopify-editor-block*="${sealAppBlockId}"]`

const getSealAppBlock = (form) => form.querySelector(sealAppBlockSelector)

const relocateSealAppBlock = (form, qtyBreaks, sealAppBlock) => {
  if (!qtyBreaks || !sealAppBlock) return false
  if (sealAppBlock.dataset.ecomifySealRelocated === 'true') return true
  if (!form.contains(qtyBreaks) || !form.contains(sealAppBlock)) return false
  if (sealAppBlock.contains(qtyBreaks)) return false

  if (qtyBreaks.previousElementSibling !== sealAppBlock) {
    qtyBreaks.insertAdjacentElement('beforebegin', sealAppBlock)
  }

  sealAppBlock.dataset.ecomifySealRelocated = 'true'
  return true
}

const scheduleSealAppBlockRelocation = (form, qtyBreaks, sealAppBlock, observer) => {
  if (sealAppBlock.dataset.ecomifySealRelocationScheduled === 'true') return

  sealAppBlock.dataset.ecomifySealRelocationScheduled = 'true'

  const relocate = () => {
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        if (relocateSealAppBlock(form, qtyBreaks, sealAppBlock)) {
          observer?.disconnect()
        }
      })
    })
  }

  if (document.readyState === 'complete') {
    relocate()
  } else {
    window.addEventListener('load', relocate, { once: true })
  }
}

const initSealEcomifyPurchaseFlow = () => {
  document.querySelectorAll('.product-content form[action*="/cart/add"]').forEach((form) => {
    const qtyBreaks = form.querySelector('#product-qty-breaks')
    if (!qtyBreaks) return

    const observer = new MutationObserver(() => {
      const sealAppBlock = getSealAppBlock(form)

      if (sealAppBlock) {
        scheduleSealAppBlockRelocation(form, qtyBreaks, sealAppBlock, observer)
      }
    })

    const sealAppBlock = getSealAppBlock(form)

    if (sealAppBlock) {
      scheduleSealAppBlockRelocation(form, qtyBreaks, sealAppBlock, observer)
    } else {
      observer.observe(form, { childList: true, subtree: true })
    }
  })
}
initSealEcomifyPurchaseFlow()

const initNadaSubscriptionLocalization = (root = document) => {
  root.querySelectorAll('[data-nada-subscription-localization]').forEach((configElement) => {
    const wrapper = configElement.closest('.nada-product-app-block--bundler')
    if (!wrapper || wrapper.dataset.nadaSubscriptionLocalizationInitialized === 'true') return

    let translations

    try {
      translations = JSON.parse(configElement.textContent)
    } catch (error) {
      console.error('Unable to parse Nada subscription translations.', error)
      return
    }

    wrapper.dataset.nadaSubscriptionLocalizationInitialized = 'true'

    const setDirectText = (element, text) => {
      if (!element || !text) return

      const textNode = Array.from(element.childNodes).find((node) => (
        node.nodeType === Node.TEXT_NODE && node.nodeValue.trim().length > 0
      ))

      if (textNode && textNode.nodeValue.trim() !== text) {
        textNode.nodeValue = text
      }
    }

    const localizeWidget = () => {
      const bundler = wrapper.querySelector('.bundler-volume-target-element')
      if (!bundler) return

      setDirectText(
        bundler.querySelector('.bndlr-subscription-container .bndlr-checkbox-container > div'),
        translations.checkbox
      )

      Object.entries(translations.quantityLabels || {}).forEach(([quantity, copy]) => {
        const quantityInput = bundler.querySelector(`input[name="bundle_quantity"][value="${quantity}"]`)
        const quantityLabel = quantityInput?.closest('.bndlr-radio-container')?.querySelector('.bndlr-text')
        if (!quantityLabel || !copy.label || !copy.benefit) return

        quantityLabel.classList.add('nada-bundler-quantity-label--shipping')
        setDirectText(quantityLabel, copy.label)

        let shippingMessage = quantityLabel.querySelector('[data-nada-bundler-free-shipping]')
        if (!shippingMessage) {
          shippingMessage = document.createElement('span')
          shippingMessage.dataset.nadaBundlerFreeShipping = 'true'
          shippingMessage.className = 'nada-bundler-free-shipping'
          quantityLabel.append(shippingMessage)
        }

        shippingMessage.textContent = ` ${copy.benefit}`
      })

      const subscriptionInput = bundler.querySelector('.sls-option[data-type="subscription"]')
      const subscriptionGroup = subscriptionInput?.closest('.sls-option-container')
      if (!subscriptionGroup) return

      setDirectText(subscriptionGroup.querySelector('.sls-selling-plan-group-name'), translations.title)
      setDirectText(subscriptionGroup.querySelector('.sls-savings-badge'), translations.savings)

      const subscriptionLine = subscriptionInput.closest('.sls-selling-plan-group-first-line')
      subscriptionInput.setAttribute('aria-label', translations.title)
      subscriptionLine?.setAttribute('aria-label', translations.title)

      const frequencySelect = subscriptionGroup.querySelector('select[name="subs_interval"]')
      const frequencyContainer = frequencySelect?.closest('.selling-plan-group-options-name-select')
      const frequencyLabel = frequencyContainer?.querySelector(':scope > label:not(.sls-selling-plan-group-first-option)')

      setDirectText(frequencyLabel, translations.deliveryFrequency)
      frequencySelect?.setAttribute('aria-label', translations.deliveryFrequency)

      Array.from(frequencySelect?.options || []).forEach((option, index) => {
        const label = translations.frequencies[index]
        if (label && option.textContent.trim() !== label) option.textContent = label
      })

      const selectedFrequency = frequencySelect?.selectedOptions[0]?.textContent.trim()
      setDirectText(
        frequencyContainer?.querySelector('.sls-selling-plan-group-first-option'),
        selectedFrequency
      )
    }

    let frameId
    const observer = new MutationObserver(() => {
      if (frameId) return

      frameId = requestAnimationFrame(() => {
        observer.disconnect()
        localizeWidget()
        observer.observe(wrapper, { childList: true, characterData: true, subtree: true })
        frameId = null
      })
    })

    wrapper.addEventListener('change', (event) => {
      if (event.target.matches('select[name="subs_interval"]')) {
        observer.disconnect()
        localizeWidget()
        observer.observe(wrapper, { childList: true, characterData: true, subtree: true })
      }
    })

    localizeWidget()
    observer.observe(wrapper, { childList: true, characterData: true, subtree: true })
  })
}
initNadaSubscriptionLocalization()
document.addEventListener('shopify:section:load', (event) => {
  initNadaSubscriptionLocalization(event.target)
})

const initNadaFirstOrderBonus = () => {
  const bonusMessages = document.querySelectorAll('[data-nada-first-order-bonus]')
  const forms = [...new Set(Array.from(bonusMessages, (message) => message.closest('form')).filter(Boolean))]

  forms.forEach((form) => {
    const messages = form.querySelectorAll('[data-nada-first-order-bonus]')

    const syncBonusMessage = () => {
      const formData = new FormData(form)
      const sellingPlan = formData.get('selling_plan')
      const quantity = Number(formData.get('quantity') || 1)
      const isSubscription = typeof sellingPlan === 'string' && sellingPlan.trim().length > 0

      messages.forEach((message) => {
        message.hidden = !isSubscription || Number(message.dataset.quantity) !== quantity
      })
    }

    form.addEventListener('change', syncBonusMessage)
    form.addEventListener('input', syncBonusMessage)
    form.addEventListener('click', () => requestAnimationFrame(syncBonusMessage), true)

    const observer = new MutationObserver(syncBonusMessage)
    observer.observe(form, { childList: true, subtree: true })

    syncBonusMessage()
  })
}
initNadaFirstOrderBonus()

function initQtyBreaks () {

  document.querySelectorAll('[name="product-qty-breaks"]').forEach(radio => {
    radio.addEventListener('change', () => {
      console.log('qty breaks change', radio)

      setAtcBtnPrice()
    })
  })

  document.querySelectorAll('.product-qty-break-variant-options select').forEach(select => {
    select.addEventListener('change', () => {
      const group = select.closest(".product-qty-break");

      const discountPercentage = Number(group.dataset.discountPercentage);
      const unitPriceCents = Number(group.dataset.unitPriceCents);
      console.log("discountPercentage", discountPercentage);

      let totalPrice = 0;
      let selectedVariants = "";

      group.querySelectorAll(".product-qty-break-variant").forEach((elem) => {
        const selectedOptions = Array.from(elem.querySelectorAll("select")).reduce((options, select) => [...options, select.value], []);

        let variantData = group.closest("form").dataset.variants
        variantData = JSON.parse(variantData);
        const selectedVariant = variantData.find((variant) => JSON.stringify(variant.options) === JSON.stringify(selectedOptions));

        console.log("selectedVariant", selectedVariant);

        if (selectedVariant) {
          totalPrice += selectedVariant.price;
          selectedVariants += `${selectedVariant.id},`;

          if (selectedVariant.available) {
            elem.querySelector(".product-qty-break-variant-sold-out").hidden = true;
          } else {
            elem.querySelector(".product-qty-break-variant-sold-out").hidden = false;
          }
        }
      });

      const priceLogic = group.dataset.priceLogic;

      if (priceLogic === "total") {
        group.querySelectorAll("[data-total]").forEach((elem) => {
          const selectedCount = selectedVariants.length ? selectedVariants.split(',').filter(Boolean).length : Number(group.querySelector("input[type='radio']").dataset.qty);
          const finalTotalPrice = group.dataset.pricingMode === "fixed" && Number.isFinite(unitPriceCents)
            ? unitPriceCents * selectedCount
            : (totalPrice * (100 - discountPercentage)) / 100;

          elem.textContent = formatMoneyWithoutTrailingZeros(finalTotalPrice);
        });
      }

      setAtcBtnPrice()

      group.querySelector("input[type='radio']").value = selectedVariants.slice(0, -1);
    })
  })

  const setAtcBtnPrice = () => {
    const qtyBreaks = document.querySelector('#product-qty-breaks')
    if (!qtyBreaks) return

    const atcBtnPrice = qtyBreaks.closest("form").querySelector(".btn-atc-price");
    if (!atcBtnPrice) return;

    let totalPrice = 0;

    const selectedGroup = getSelectedQtyBreakGroup(qtyBreaks);
    if (!selectedGroup) return;

    const discountPercentage = Number(selectedGroup.dataset.discountPercentage);
    const datasetTotalPrice = Number(selectedGroup.dataset.totalPriceCents);

    if (selectedGroup.dataset.pricingMode === "fixed" && Number.isFinite(datasetTotalPrice) && datasetTotalPrice > 0) {
      atcBtnPrice.textContent = formatMoneyWithoutTrailingZeros(datasetTotalPrice);
      return;
    }

    if (!selectedGroup.querySelector(".product-qty-break-variant") && Number.isFinite(datasetTotalPrice) && datasetTotalPrice > 0) {
      atcBtnPrice.textContent = formatMoneyWithoutTrailingZeros(datasetTotalPrice);
      return;
    }

    selectedGroup.querySelectorAll(".product-qty-break-variant").forEach((elem) => {
      const selectedOptions = Array.from(elem.querySelectorAll("select")).reduce((options, select) => [...options, select.value], []);

      let variantData = qtyBreaks.closest("form").dataset.variants
      variantData = JSON.parse(variantData);
      const selectedVariant = variantData.find((variant) => JSON.stringify(variant.options) === JSON.stringify(selectedOptions));

      if (selectedVariant) {
        totalPrice += selectedVariant.price;
      }
    });

    atcBtnPrice.textContent = formatMoneyWithoutTrailingZeros((totalPrice * (100 - discountPercentage)) / 100);
  }
  setAtcBtnPrice()
}
initQtyBreaks()

const initNadaPreferredVariant = () => {
  const form = document.querySelector('#product-template .product-content form[action*="/cart/add"]')
  if (!form?.dataset.variants) return

  const url = new URL(window.location.href)
  if (url.searchParams.has('variant')) return

  let variants

  try {
    variants = JSON.parse(form.dataset.variants)
  } catch (error) {
    return
  }

  const preferredVariant = variants.find((variant) =>
    [variant.title, ...(variant.options || [])].some((value) => /(^|\D)140(\D|$)/.test(String(value)))
  )

  const idInput = form.querySelector('[name="id"]')

  if (!preferredVariant || !idInput || Number(idInput.value) === Number(preferredVariant.id)) return

  const optionGroups = []

  form.querySelectorAll('.product-option').forEach((control) => {
    const key = control.name || control.id
    let group = optionGroups.find((item) => item.key === key)

    if (!group) {
      group = { key, controls: [] }
      optionGroups.push(group)
    }

    group.controls.push(control)
  })

  let firstChangedControl = null

  preferredVariant.options.forEach((optionValue, index) => {
    const control = optionGroups[index]?.controls.find((item) => item.value === optionValue)
    if (!control) return

    if (control.type === 'radio') {
      control.checked = true
    } else {
      control.value = optionValue
    }

    firstChangedControl = firstChangedControl || control
  })

  if (firstChangedControl) {
    window.onChangeProductOption(firstChangedControl)
  }
}
initNadaPreferredVariant()

const getFormDataFromQtyBreaks = async (form) => {
  const qtyBreaks = form.querySelector('#product-qty-breaks')
  if (!qtyBreaks) return null

  if (getSelectedSellingPlan(form)) return null

  const selectedGroup = getSelectedQtyBreakGroup(qtyBreaks);
  if (!selectedGroup) return null

  const variantIds = selectedGroup.querySelector('input[type="radio"]').value.split(',')
    .map((variantId) => Number(variantId))
    .filter((variantId) => Number.isFinite(variantId) && variantId > 0);

  if (!variantIds.length) return null

  const formData = new FormData(form);

  formData.delete("selling_plan");

  const properties = {};
  for (const [key, value] of formData.entries()) {
    if (key.startsWith("properties[")) {
      const cleanKey = key.replace("properties[", "").replace("]", "");
      properties[cleanKey] = value;
    }
  }

  Object.keys(properties).forEach((p) => {
    formData.delete(`properties[${p}]`);
  });

  formData.delete("id");
  formData.delete("quantity");

  variantIds.forEach((variantId, index) => {
    const base = `items[qty-breaks-${index}]`;

    formData.append(`${base}[id]`, variantId);
    formData.append(`${base}[quantity]`, 1);

    Object.keys(properties).forEach((p) => {
      formData.append(`${base}[properties][${p}]`, properties[p]);
    });
  });

  return formData

}

/*
    Prev/Next Products (will show only if the product is within a collection)
*/
const initPrevNextButtons = async () => {
  const wrapper = document.querySelector('#product-prev-next')

  if (!wrapper) return

  if (!window.matchMedia('(max-width: 1599px)').matches) return

  await new Promise(resolve => setTimeout(resolve, 1000))

  const threshold = document.querySelector('.product-content form[action*="/cart/add"]').getBoundingClientRect().bottom + window.scrollY

  console.log(threshold)

  window.addEventListener('scroll', () => {
    if (window.scrollY > threshold) {
      wrapper.classList.add('show')
    } else {
      wrapper.classList.remove('show')
    }
  })
}
initPrevNextButtons()

/*
    Personalization (Custom properties)
*/
const initPersonalization = () => {
  document.querySelectorAll('.product-personalization-field[data-type="checkbox"]').forEach(elem => {
    let values = []

    elem.querySelectorAll('input').forEach(checkbox => {
      checkbox.addEventListener('change', () => {
        if (checkbox.checked) {
          values.push(checkbox.value)
        } else {
          values = values.filter((item) => item !== checkbox.value)
        }

        elem.querySelector('[type="hidden"]').value = values.join(', ')
      })
    })
  })
}
initPersonalization()

/*
    Limited Offer
*/
const initLimitedOffer = () => {
  const block = document.querySelector('#product-limited-offer')

  if (!block) return

  const icon = block.querySelector('.block-icon')

  setInterval(() => {
    icon.classList.add('animate__animated', 'animate__tada')

    setTimeout(() => {
      icon.classList.remove('animate__animated', 'animate__tada')
    }, 1500)
  }, 3000)
}
initLimitedOffer()

/*
    Sync quantity between the product form, Sticky ATC, etc
*/
const initSyncQuantity = () => {
  const productFormQtyInput = document.querySelector('.product-buy-buttons input[name="quantity"]')

  if (!productFormQtyInput) return

  productFormQtyInput.addEventListener('change', () => {
    const stickyAtcQtyInput = document.querySelector('#sticky-atc input[name="quantity"]')

    if (!stickyAtcQtyInput) return

    stickyAtcQtyInput.value = productFormQtyInput.value
  })
}
initSyncQuantity()


/*
 product-progress-block
*/
document.addEventListener('DOMContentLoaded', function () {
  const productProgressCircles = document.querySelectorAll('.product-progress-circle');
  productProgressCircles.forEach(circle => {
    const targetPercentage = parseInt(circle.dataset.percentage);
    const valueDisplay = circle.querySelector('.progress-value');
    let currentPercentage = 0;

    const animateProgress = () => {
      if (currentPercentage < targetPercentage) {
        currentPercentage++;
        circle.style.setProperty('--percentage', currentPercentage + '%');
        valueDisplay.textContent = currentPercentage + '%';
        requestAnimationFrame(animateProgress);
      }
    };

    setTimeout(animateProgress, 100);
  });
});
